import React, { Component } from 'react';
import { LoginContainer, Image, Button, Signup } from './components';
import { ScreenWrapper, Hint } from '../../components/general';
import logo from '../../assets/logo.svg';
import { AuthContext } from '../../contexts/auth';

class Home extends Component {
	render() {
		const auth = this.context;
		return (
			<ScreenWrapper>
				<LoginContainer>
					<Image src={logo} />
					<Hint>
						<br />
						Welcome to Open Health Dashboard.
						<br />
						Please click below to log in
					</Hint>
					<br />
					<Button onClick={() => window.location = auth.loginURL}>
						Log In
					</Button>
					<br />
					<br />
					<Signup>Need an account? <a href={auth.loginURL}>Sign up</a></Signup>
				</LoginContainer>
			</ScreenWrapper>
		);
	}
};

Home.contextType = AuthContext;
export default Home;
